/* eslint-disable no-console */

import axios from 'axios';
import router from '../router';
import store from '../store/store';
import config from './config/config';

const HTTPEdition = axios.create();

// Add a request interceptor
HTTPEdition.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + store.getters['user/accessToken'],
  };
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.URL_SERVEUR + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
HTTPEdition.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 401) {
    const site = store.getters['user/site'];
    router.push({ name: 'login', query: { site: site, returnUrl: window.location.href } });
    // Toast ou message d'erreur si nécessaire
    console.warn('Session expirée');
  }
  throw error;
});

export default HTTPEdition;